// eslint-disable-next-line import/prefer-default-export
export const USER_TYPE = {
	SUPER_ADMIN: 'Superadmin',
	ADMIN: 'Admin',
};
